module.exports = __webpack_public_path__ + "static/img/identity-back.79cf4992.png";